/**
 * @license Copyright (c) 2003-2018, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md.
 */
/**
 * @module basic-styles/strikethrough/strikethroughui
 */
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';
import strikethroughIcon from '../../theme/icons/strikethrough.svg';
const STRIKETHROUGH = 'strikethrough';
/**
 * The strikethrough UI feature. It introduces the Strikethrough button.
 *
 * @extends module:core/plugin~Plugin
 */
export default class StrikethroughUI extends Plugin {
    /**
	 * @inheritDoc
	 */
    init() {
        const editor = this.editor;
        const t = editor.t;
        // Add strikethrough button to feature components.
        editor.ui.componentFactory.add(STRIKETHROUGH, locale => {
            const command = editor.commands.get(STRIKETHROUGH);
            const view = new ButtonView(locale);
            view.set({
                label: t('x'),
                icon: strikethroughIcon,
                keystroke: 'CTRL+SHIFT+X',
                tooltip: true
            });
            view.bind('isOn', 'isEnabled').to(command, 'value', 'isEnabled');
            // Execute command.
            this.listenTo(view, 'execute', () => editor.execute(STRIKETHROUGH));
            return view;
        });
    }
}


//////////////////
// WEBPACK FOOTER
// ../ckeditor5-basic-styles/src/strikethrough/strikethroughui.js
// module id = null
// module chunks = 